/**
 *
 */
const setupMainMenu = () =>
{
	const allSubMenus        = document.querySelectorAll( '#main-menu .sub-menu' );
	const firstLevelSubMenus = document.querySelectorAll( '#main-menu > li > .sub-menu' );
	const deepNestedMenus    = document.querySelectorAll( '#main-menu > li > .sub-menu > li .sub-menu' );

	// make submenus after the 3rd main item open left

	firstLevelSubMenus.forEach( ( subMenu, key ) =>
	{
		const subSubMenus = subMenu.querySelectorAll( '.sub-menu' );

		if (key > 2) {
			subSubMenus.forEach( subSubMenu => subSubMenu.classList.add( 'opens-left' ) );
		}
	} );

	// make any submenus nested deeper than 2 open to the left

	deepNestedMenus.forEach( subMenu =>
	{
		const subSubMenus = subMenu.querySelectorAll( '.sub-menu' );

		subSubMenus.forEach( subSubMenu => subSubMenu.classList.add( 'opens-left' ) );
	} );

	// prevent flash of submenus while stylesheet is being loaded

	setTimeout( () =>
	{
		allSubMenus.forEach( subMenu =>
		{
			if (subMenu instanceof HTMLElement) {
				subMenu.style.removeProperty( 'visibility' );
			}
		} );
	}, 500 );
};


/**
 *
 */
export default setupMainMenu;